import Swiper from 'swiper/bundle';
import { updateSwiperStatus, updateSlidesInert } from '../utils/accessibility-swiper';

const syncSlidesInert = (swiper) => {
  window.requestAnimationFrame(() => {
    updateSlidesInert(swiper, 'visible');
  });
};

export function initUpgradePlusSlider() {
  const sliderEl = document.querySelector('.upgrade-plus-page__cards-slider');
  if (!sliderEl) return;

  // Проверяем, что мы на мобильной версии (md breakpoint = 768px)
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (!isMobile) return; // Не инициализируем слайдер на десктопе

  const AUTOPLAY_DELAY = 5000; // 5s
  let lastActiveIndex = 0;
  const locale = window.Shopify?.locale || 'uk';
  const getAutoplayLabel = isPlaying => (
    locale === 'ru'
      ? (isPlaying ? 'Остановить воспроизведение' : 'Запустить воспроизведение')
      : (isPlaying ? 'Зупинити програвання' : 'Запустити програвання')
  );

  const upgradePlusSlider = new Swiper(sliderEl, {
    slidesPerView: 1.5,
    spaceBetween: 12,
    watchSlidesProgress: true,
    autoplay: {
      delay: AUTOPLAY_DELAY,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.upgrade-plus-page__pagination',
      clickable: true,
    },
    a11y: false,
    watchSlidesProgress: true,
    on: {
      init(swiper) {
        setTimeout(() => {
          swiper.slides.forEach(slide => {
            slide.removeAttribute('role');
          });
          updateSlidesInert(swiper, 'visible');
        }, 0);

        updateSwiperStatus(swiper);
        lastActiveIndex = swiper.snapIndex;
        syncSlidesInert(swiper);
      },

      slideChange(swiper) {
        updateSwiperStatus(swiper);
        updateSlidesInert(swiper, 'visible');

        const bullets = swiper.pagination.bullets;
        // скидаємо прогрес у попереднього булета
        if (bullets[lastActiveIndex]) {
          bullets[lastActiveIndex].style.setProperty('--progress', 0);
        }
        lastActiveIndex = swiper.snapIndex;
        syncSlidesInert(swiper);
      },

      transitionEnd(swiper) {
        syncSlidesInert(swiper);
      },

      resize(swiper) {
        syncSlidesInert(swiper);
      },

      // тут від Swiper отримуємо прогрес autoplay
      autoplayTimeLeft(swiper, time, progress) {
        const bullets = swiper.pagination.bullets;
        const activeBullet = bullets[swiper.snapIndex];
        if (!activeBullet) return;

        // progress: 0 → тільки почалося, 1 → зараз переключиться
        activeBullet.style.setProperty('--progress', 1 - progress);
      },
    },
  });

  // кнопка Play / Pause
  const autoplayToggleBtn = document.querySelector('.upgrade-plus-page__button');

  if (autoplayToggleBtn) {
    autoplayToggleBtn.setAttribute('aria-label', getAutoplayLabel(true));

    autoplayToggleBtn.addEventListener('click', () => {
      if (!upgradePlusSlider.autoplay) return;

      if (upgradePlusSlider.autoplay.running) {
        upgradePlusSlider.autoplay.stop();
        autoplayToggleBtn.classList.add('is-paused');
        autoplayToggleBtn.setAttribute('aria-label', getAutoplayLabel(false));
      } else {
        upgradePlusSlider.autoplay.start();
        autoplayToggleBtn.classList.remove('is-paused');
        autoplayToggleBtn.setAttribute('aria-label', getAutoplayLabel(true));
      }
    });
  }
}
